import {
  BookingSummary,
  PaymentHistory,
  PaymentInfo,
  AttendeesDetails,
} from '.'

// type BookingDetailsProps = {
//   booking: any
//   trip: any
//   user: any
//   getBooking: any
//   showPaymentButton: any
// }

export const BookingDetails = ({
  booking,
  trip,
  user,
  getBooking,
  showPaymentButton,
}: any) => {
  const unapprovedCryptoPayment =
    booking.cryptoPaymentMethod && !booking.paymentHistory

  return (
    <>
      {unapprovedCryptoPayment && (
        <div className="alert alert-warning">
          <h4 className="alert-heading">Crypto Payment Pending</h4>
          <p>
            This transaction has been preapproved, but the payment has not yet
            been executed.
          </p>
          <p>Approve the booking request to execute the payment.</p>
        </div>
      )}
      {!unapprovedCryptoPayment && (
        <div className='booking-details-border'>
          <PaymentInfo
            booking={booking}
            trip={trip}
            getBooking={getBooking}
            showPaymentButton={showPaymentButton}
          />
        </div>
      )}
      <div className='booking-details-border border-off'><BookingSummary booking={booking} trip={trip} /></div>
      {booking?.paymentHistory?.length > 0 && <div className='booking-details-border'><PaymentHistory booking={booking} trip={trip} /></div>}
      {/* {(booking?.guests?.length > 0 && booking?.attendees > 1) && <div className='booking-details-border'><AttendeesDetails guests={booking.guests} user={user} /></div>} */}
    </>
  )
}
